import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { LoadingButton } from 'src/components/buttons/LoadingButton';
import Stack from '@mui/material/Stack';
import { useAuth } from 'src/contexts/AuthContext';
import { AuthenticationFlowPageProps } from '../AuthenticationFlow';
import { useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { reset } from '../store/authSlice';
import CheckCircleOutlineRoundedIcon from '@mui/icons-material/CheckCircleOutlineRounded';
import { getUsername } from 'src/util/getUsername';
import { LottieLoader } from 'src/components/LottieLoader';
export type AuthenticationVerifyingEmailPageProps = AuthenticationFlowPageProps;

export const AuthenticationVerifyingEmailPage = ({
  pageId,
  onPageComplete,
}: AuthenticationVerifyingEmailPageProps) => {
  const [resent, setResent] = useState(false);
  const intervalId = useRef<number | null>(null);
  const dispatch = useDispatch();
  const { user, handleSignOut } = useAuth();

  useEffect(() => {
    if (!user?.emailVerified) {
      intervalId.current = setInterval(() => {
        user?.reload();
      }, 2500) as unknown as number;
    }
    return () => {
      clearInterval(intervalId.current as number);
    };
  }, [user, user?.emailVerified]);
  // const handleConnectWallet = () => {
  // TODO
  // };
  const resetAuth = async () => {
    await handleSignOut();
    dispatch(reset());
    onPageComplete(pageId, 'registration start');
  };
  const resendEmail = async () => {
    if (!user || !user.email) {
      return;
    }
    const { sendAuthEmail } = await import(
      '../../../firebaseCloud/mail/sendAuthEmail'
    );
    try {
      await sendAuthEmail({
        to: user.email,
        mode: 'verifyEmail',
        username: await getUsername(user.email),
      });
    } catch (e) {
      console.error(e);
    }
    setResent(true);
  };

  useEffect(() => {
    if (user?.emailVerified) {
      onPageComplete(pageId, 'verifying email success');
    }
  }, [onPageComplete, pageId, user?.emailVerified]);
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
      }}
    >
      <Stack spacing="32px">
        <Typography variant="h4" textTransform="capitalize" textAlign="center">
          Verify Your Email
        </Typography>
        <Box sx={{ display: 'flex', justifyContent: 'center', my: 4 }}>
          <LottieLoader sx={{ height: '100px', width: '100px' }} />
        </Box>
        <Typography variant="h6" textAlign="center" sx={{ my: 4 }}>
          Please click the link in the email <br /> we have just sent to{' '}
          {user?.email}.
        </Typography>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 2,
          }}
        >
          <LoadingButton
            variant="contained"
            color="error"
            size="large"
            onClick={resetAuth}
          >
            Cancel
          </LoadingButton>
          <LoadingButton
            variant="contained"
            size="large"
            onClick={resendEmail}
            fullWidth
            endIcon={resent ? <CheckCircleOutlineRoundedIcon /> : undefined}
          >
            Resend Email
          </LoadingButton>
        </Box>
      </Stack>
    </Box>
  );
};
